module.exports = __webpack_public_path__ + "static/media/gonggamin_narrow.f91f5f27.png";